import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "estore-service";

export default {
    getOrders(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v3/cms/estore/order/list/" + param.page,
                param.payload,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getOrdersPointsEarned(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/estore/order/points/earned",
                param,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getStatusOption() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/v1/cms/estore/order/option/statuses", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getColumnsOption() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/v2/cms/estore/order/option/columns", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateStatus(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/v2/cms/estore/order/update/status/" +
                    param.uuid,
                param.payload,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    cancelOrder(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v1/cms/estore/order/cancel/" + param.uuid,
                param.payload,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getOrderTransactionDetails(param) {
        return new Promise((resolve, reject) => {
            // /v2/cms/estore/order/details/${param.uuid}
            api.get(
                `${BASE_SERVICE_URL}/v3/cms/estore/order/transaction/details/${param.uuid}`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateDepositSlipStatus(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/v2/cms/estore/order/deposit_slip/" +
                    param.uuid,
                param.payload,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    exportHistory(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v2/cms/estore/order/export",
                param,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getPaymentExpressHistory({ page, filters }) {
      return new Promise((resolve, reject) => {
        api.post(
          `${BASE_SERVICE_URL}/v1/cms/estore/orders/payment-express/list/${page}`,
          { filters },
          { Authorization: auth.getToken() }
        )
          .then(response => {
            return resolve(response);
          })
          .catch((status, error) => {
            reject(status, error);
          });
      });
    },
};
